import { InitialState } from './types';

export default ({ currentUser }: InitialState) => ({
  alerts: currentUser?.permissions.includes('alerts'),
  classLabels: currentUser?.permissions.includes('class_labels'),
  devices: currentUser?.permissions.includes('devices'),
  labels: currentUser?.permissions.includes('labels'),
  manageClassLabels: currentUser?.permissions.includes('manage_class_labels'),
  manageLabels: currentUser?.permissions.includes('manage_labels'),
  reports: currentUser?.permissions.includes('reports'),
  samples: currentUser?.permissions.includes('samples'),
  settings: currentUser?.permissions.includes('settings'),
  thresholds: currentUser?.permissions.includes('thresholds'),
  users: currentUser?.permissions.includes('users'),
});
